import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { BookOpen, Sparkle } from '@phosphor-icons/react';

/**
 * BubbleJournal — lists existing journals for a bubble and lets owner
 * spawn a new $10 AI storybook. Each journal contains 3 Claude chapters
 * generated from the bubble's mythology ledger.
 */
const BubbleJournal = ({ bubble, isOwner }) => {
  const [journals, setJournals] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get(`/bubbles/${bubble.id}/journals`);
      setJournals(data.journals || []);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, [bubble.id]); // eslint-disable-line

  const buy = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/bubbles/${bubble.id}/journal/buy`, {
        bubble_id: bubble.id,
        origin_url: window.location.href,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'could not write it');
      setBusy(false);
    }
  };

  return (
    <div className="glass rounded-2xl p-5" data-testid="bubble-journal">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <BookOpen size={16} className="text-bx-gold" weight="duotone" />
          <h3 className="font-display font-bold">Bubble Journal</h3>
        </div>
        {isOwner && (
          <button
            onClick={buy}
            disabled={busy}
            data-testid="buy-journal-btn"
            className="text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-full bg-bx-gold/15 hover:bg-bx-gold/25 text-bx-gold disabled:opacity-50 flex items-center gap-1">
            <Sparkle size={10} weight="fill" /> {busy ? '…' : 'New chapter · $10'}
          </button>
        )}
      </div>

      {journals.length === 0 ? (
        <div className="text-xs text-white/45 italic">
          {bubble.name} hasn't dictated a journal yet.
          {isOwner && ' Buy one to let Claude transcribe their first three chapters.'}
        </div>
      ) : (
        <div className="space-y-4">
          {journals.map((j) => (
            <div key={j.id} data-testid={`journal-${j.id}`}>
              <div className="text-[10px] uppercase tracking-widest text-white/60">
                {new Date(j.created_at).toLocaleDateString()} · {j.chapters?.length || 0} chapters
              </div>
              <div className="mt-2 space-y-3">
                {(j.chapters || []).map((c, idx) => (
                  <div key={idx} className="border-l-2 border-bx-gold/60 pl-3">
                    <div className="text-sm font-bold text-bx-gold">{c.title}</div>
                    <div className="text-sm text-white/80 italic mt-1">{c.body}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BubbleJournal;
